const heroChartHandlers = () => {
	// Exit as soon as possible.
	const promos = document.querySelectorAll('.hero-chart-main-block .hero-chart-promo');
	if (!promos) return;

	promos.forEach(promo => {
		if (!promo) return;
		heroChartDisclaimerHandler(promo)
		buttonCopy(promo)
		clickOnPromoWithCode(promo);
	})
}

/**
 * Toggle hero chart disclaimer.
 * @returns void
 */
const heroChartDisclaimerHandler = (promo) => {
	const triggers = promo.querySelectorAll('.disclaimer-toggle');
	const disclaimer_text = promo.querySelector('.promo-disclaimer-full');
	// Exit if disclaimer is hidden.
	if (!triggers || !disclaimer_text) return

	triggers.forEach(trigger => {
		trigger.addEventListener("click", (e) => {
			e.preventDefault();
			// Toggle disclaimer visibilty.
			disclaimer_text.classList.toggle('open');
		})
	})
}

/**
 * Copy text to clipboard.
 * @param {string} text 
 * @returns 
 */
const copyToClipboard = async (text) => {
	if (navigator.clipboard) {
		try {
			return await navigator.clipboard.writeText(text);
		} catch {
			return await fallbackCopyTextToClipboard(text);
		}
	} else {
		return fallbackCopyTextToClipboard(text);
	}
}

/**
 * Fallback function if navigator.clipboard fails.
 * @param {string} text
 * @returns 
 */
const fallbackCopyTextToClipboard = (text) => {
	return new Promise((resolve, reject) => {
		const textarea = document.createElement("textarea");
		textarea.value = text;
		textarea.style.position = "fixed"; // Prevent scrolling to bottom of page
		document.body.appendChild(textarea);
		textarea.focus();
		textarea.select();

		try {
			const successful = document.execCommand("copy");
			if (successful) {
				resolve();
			} else {
				reject(new Error("Fallback: Unable to copy text."));
			}
		} catch (err) {
			reject(err);
		} finally {
			document.body.removeChild(textarea);
		}
	});
}

const clickCopyBonusButtonHandler = (promo, button) => {
	const clickoutLink = promo.href;
	const bonusCode = button.dataset.bonus;

	if (!bonusCode) {
		console.warn("No bonus code found to copy.");
		return;
	}

	copyToClipboard(bonusCode)
		.then(() => {
			button.classList.add("copied");
			window.sessionStorage.setItem("copied_code", bonusCode)
			setTimeout(() => {
				button.classList.remove("copied");
				if (clickoutLink) {
					window.open(clickoutLink, "_blank");
				}
			}, 2000);
		})
		.catch(err => {
			console.error("Failed to copy text:", err);
		});

}

/**
 * Copy bonus & redirect user.
 * @param {object} promo Promo item.
 * @returns 
 */
const buttonCopy = (promo) => {
	const promoCodes = promo.querySelectorAll('.bonus-copy');
	if (!promoCodes) return;

	promoCodes.forEach(button => {
		button.addEventListener('click', (e) => {
			e.preventDefault();
			clickCopyBonusButtonHandler(promo, button);
		})
	})
}

const collectAmplitudeData = (promo, event = 'Clickout', paramEventName = 'promo_code_popup_seen', paramBlockType = 'hero_chart') => {
	if (!window.amplitude || typeof (sdl_clickouts_data) === 'undefined' || typeof (sl_analytics_data) === 'undefined') {
		return false;
	}

	const parameters = sl_analytics_data.clickoutData.hero_chart.properties;
	const properties = {};
	const vertical = sl_analytics_data.vertical;
	const abData = getABData();
	let chartAmpData = promo.dataset.amp,
		clickout = '',
		highlighted = '';

	if (!chartAmpData) {
		let amp_el = promo.querySelector('[data-amp]');
		chartAmpData = amp_el ? amp_el.dataset.amp : '';
	}

	if (chartAmpData) {
		chartAmpData = JSON.parse(chartAmpData);
		Object.assign(properties, chartAmpData)
	}

	properties['event_name'] = paramEventName;
	properties['wordpress'] = 1;
	properties['block_type'] = paramBlockType;
	properties['postback_unique_id'] = getUniqueUserId();
	properties['vertical'] = vertical;
	properties['region'] = sdl_clickouts_data.slug;

	// Add AB testing data to the props.
	Object.assign(properties, abData);

	// Check if chart item is a clickout link.
	if (promo.classList.contains('clickout-replace')) {
		clickout = promo;
	} else {
		clickout = promo.querySelectorAll('.clickout-replace');
	}

	const link = slAnalyticsGetLink(promo)
	if (!link) return;

	const data = collectData(promo, parameters, properties)

	amplitude.track(event, properties)
}

/**
 * Popup open.
 * @param {*} popup Popup element.
 * @param {*} promo Promo item element.
 * @returns 
 */
const openPromoCodePopupHandler = (popup, promo) => {
	if (!popup) return;

	// Open popup.
	popup.classList.add('open');

	// Send data to amplitude.
	collectAmplitudeData(promo, 'promo_code_popup_seen', 'promo_code_popup_seen');
}

/**
 * Close the popup window and clear the data.
 * @param {object} popup Current promo element.
 * @param {object} popupCodeValue Bonus code element.
 * @param {object} popupCopyButton Copy button element.
 */
const closePromoCodePopupHandler = (popup, popupCodeValue = null, popupCopyButton = null) => {
	popup.classList.remove('open');
	popup.classList.remove('success');
	// popup.style.opacity = 0;
	popupCodeValue.textContent = 'No code';
	popupCopyButton.dataset.bonus = '';
}

/**
 * Close popup handler.
 * @param {object} popup Popup element. 
 * @param {string} popupCodeValue Promo code value.
 * @param {object} popupCopyButton Copy buttin element.
 * @returns 
 */
const clickClosePopup = (popup, popupCodeValue = null, popupCopyButton = null, promo) => {
	const closeBtn = popup.querySelectorAll('.btn-close');

	if (!closeBtn) return;

	closeBtn.forEach(close => {
		close.addEventListener('click', (e) => {
			e.preventDefault();
			closePromoCodePopupHandler(popup, popupCodeValue, popupCopyButton);

			const clickAction = close.dataset.action || 'outside_banner_close';

			if (!window.amplitude || typeof (sdl_clickouts_data) === 'undefined') {
				return false;
			}

			const properties = {};

			let chartAmpData = promo.dataset.amp;

			if (!chartAmpData) {
				let amp_el = promo.querySelector('[data-amp]');
				chartAmpData = amp_el ? amp_el.dataset.amp : '';
			}

			if (chartAmpData) {
				chartAmpData = JSON.parse(chartAmpData);
				Object.assign(properties, chartAmpData)
			}

			const vertical = sl_analytics_data.vertical;
			properties['event_name'] = 'close_promo_popup';
			properties['click_action'] = clickAction;
			properties['wordpress'] = 1;
			properties['postback_unique_id'] = getUniqueUserId();
			properties['vertical'] = vertical;
			properties['region'] = sdl_clickouts_data.slug;

			amplitude.track('close_promo_popup', properties)
		});
	})
}

/**
 * 
 * @param {object} promo Current promo element.
 * @param {string} promoCode Promo code value.
 * @returns 
 */
const promoCodePopupHandler = (promo, promoCode) => {
	if (!promo || !promoCode) return;

	const popup = document.querySelector('.hero-chart-popup');
	// If for some reason popup doens't exist.
	if (!popup) return;

	const popupCodeValue = popup.querySelector('.promo-code-value-text');
	const popupCopyButton = popup.querySelector('.bonus-copy');
	// const clickoutLink = promo.href;

	popupCodeValue.textContent = promoCode;
	popupCopyButton.dataset.bonus = promoCode;

	// Open popup.
	openPromoCodePopupHandler(popup, promo)

	// Click on copy button.
	popupCopyButton.addEventListener('click', (e) => {
		e.preventDefault();
		collectAmplitudeData(promo, 'Clickout', 'copy_popup_promo_code', 'promo_code_pop_up')
		clickCopyBonusButtonHandler(promo, popupCopyButton);

		popup.classList.add('success')

		setTimeout(() => {
			closePromoCodePopupHandler(popup, popupCodeValue, popupCopyButton);
		}, 3000)
	});

	clickClosePopup(popup, popupCodeValue, popupCopyButton, promo)
}

/**
 * Click on offer with promo code handler.
 * @param {object} promo Promo item. 
 */
const clickOnPromoWithCode = (promo) => {
	const promoCodes = promo.querySelectorAll('.bonus-copy');
	if (!promoCodes || promoCodes.length === 0) return;

	promo.addEventListener('click', (evnt) => {
		const copiedText = window.sessionStorage.getItem('copied_code') || '';
		// Get promo code from Amplitude data.
		const parseAmplitudeData = JSON.parse(promo.dataset.amp)
		const promoCode = parseAmplitudeData.promo_code_text || '';

		if (copiedText !== promoCode && !evnt.target.closest('.bonus-copy')) {
			evnt.preventDefault();

			promoCodePopupHandler(promo, promoCode)
		} else {
			console.log('Copied code belongs to the current promo');
		}
	})
}

document.addEventListener("DOMContentLoaded", () => {
	heroChartHandlers()
})
